// What a signed-out visitor on the apex gets at a public site path (see boot.js). The public pages alone; the app chunk loads only when they navigate off them
// (Sign in, Terms, Privacy...). Once loaded, the app stays: after signing in,
// `/` is the dashboard, not the marketing page again.
import React, { Suspense, lazy, useEffect, useState } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { isPublicPath } from './boot';

export const loadSite = () => import('./components/pages/marketing/Site');
const Site = lazy(loadSite);
const AppInRouter = lazy(() => import('./App').then((m) => ({ default: m.AppInRouter })));

const Blank = () => <div style={{ minHeight: '100vh' }} />;

export function PublicSwitch() {
  const { pathname } = useLocation();
  const onPage = isPublicPath(pathname);
  const [left, setLeft] = useState(!onPage);
  useEffect(() => { if (!onPage) setLeft(true); }, [onPage]);

  return (
    <Suspense fallback={<Blank />}>
      {onPage && !left ? <Site /> : <AppInRouter />}
    </Suspense>
  );
}

export default function PublicRoot() {
  return (
    <BrowserRouter>
      <PublicSwitch />
    </BrowserRouter>
  );
}
